/* RealityLink Arena — Bookings: 4-step reservation wizard + event request.
   Sessions: live slots from Supabase get_availability -> hold_slot (20 min) -> Shopify cart
   (lines carry the hidden _booking_id) -> /checkout. The DB is owned by the ops-console repo;
   this file only calls its two public RPCs with the publishable (anon) key.
   Private-event requests still use the contact form (evtForm). */
(function () {
  var RL = (window.RL = window.RL || {});
  var root = document.querySelector('[data-booking]');
  if (!root) return;

  /* Whole dollars like the rest of the site ($25, $90); cents only when a total isn't whole
     (10% squad rate on an odd party: 5 x $25 x 0.9 = $112.50). */
  function fmt(n) { var c = Math.round(n * 100); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  var XPS = [
    { id: 'freeroam',   name: 'Free Roam 30 — Basic',   short: '30 Min — Basic',   meta: '30 MIN · 1–8 PLAYERS', desc: 'One untethered mission, basic lineup.', min: 1, max: 8, squad: true },
    { id: 'freeroamp',  name: 'Free Roam 30 — Premium', short: '30 Min — Premium', meta: '30 MIN · 1–8 PLAYERS', desc: 'One mission, premium title lineup.', min: 1, max: 8, squad: true },
    { id: 'freeroam2',  name: 'Free Roam 60 — Basic',   short: '60 Min — Basic',   meta: '60 MIN · 1–8 PLAYERS', desc: 'A full hour on the grid, basic lineup.', min: 1, max: 8, squad: true },
    { id: 'freeroam2p', name: 'Free Roam 60 — Premium', short: '60 Min — Premium', meta: '60 MIN · 1–8 PLAYERS', desc: 'A full hour, premium title lineup.', min: 1, max: 8, squad: true },
    /* Omni prices by PLAY, not by player: first play full price, every later play the same
       day is discounted. Manufacturer-recommended shape — it exists to pull repeat plays.
       ponytail: max 6 plays ≈ 60 min of pod time; raise it if guests really book longer. */
    { id: 'omni', slug: 'omni-single', name: 'Omni — Single Play',      short: 'Single Play',      meta: '10 MIN PER PLAY · 1–4 PLAYERS', desc: '', perPlay: true, min: 1, max: 4 },
    /* groupOf is a FULL squad, not a ceiling: $80 only beats 4 singles ($92) at exactly 4
       players. At 3 or fewer the guest overpays, so never sell this as "up to 4". */
    { id: 'omnig', slug: 'omni-group', name: 'Omni — Group Play',       short: 'Group Play',       meta: '10 MIN PER PLAY · FULL SQUAD OF 4', desc: '', perPlay: true, groupOf: 4, min: 4, max: 4 },
    { id: 'dreampark',  name: 'Dream Park',              short: 'Explorer',         meta: '45 MIN · 1–10 PLAYERS', desc: 'Mixed reality, all ages.', min: 1, max: 10 },
    { id: 'dreampark4', name: 'Dream Park Four-Pack',    short: 'Four-Pack',        meta: '45 MIN · FLAT RATE', desc: '4 players, one shared world.', min: 4, max: 4, flat: true }
  ];
  var SB_URL = 'https://panacdzyyjrwvzavgory.supabase.co';
  var SB_KEY = 'sb_publishable_3fkIYd1pboCALWdSHsmaDw_CN-hs9z-'; /* publishable/anon key: public-safe */
  var TZ = 'America/New_York';
  var MAX_DAYS = 90;
  /* Shopify variant ids keyed by booking.slug then variant title, emitted by rl-bookings.liquid */
  var VARIANTS = {};
  try { VARIANTS = JSON.parse((root.querySelector('[data-variants]') || {}).textContent || '{}'); } catch (e) {}
  /* Squad discount: 10% off per-player pricing once a party reaches SQUAD_MIN. Only applies
     to products flagged `squad` — Dream Park has its own flat-rate Four-Pack instead, and
     the Omni products price by tier lookup. This is the ONE manual mirror: it mirrors the Shopify AUTOMATIC
     discount "Squad Discount — 10% off 4+ Free Roam passes" (storefront JS cannot read it) and
     squad_min/squad_pct in sections/rl-experience-free-roam-b.liquid. Change all three together. */
  var SQUAD_MIN = 4, SQUAD_OFF = 0.10;
  /* Must stay ABOVE the ?xp= preset below: that calls selectXp() -> clamp() -> playsMax()
     at load time, and a `var` declared later is hoisted-but-undefined, which silently
     turned state.plays into NaN. Keep every pricing constant above the preset. */
  var PLAYS_PER_PERSON_MAX = 6;

  function slugOf(x) { return x.slug || x.id; }
  /* Prices come LIVE from Shopify (variant price, cents) via VARIANTS: price = first/only variant,
     extra = 'Additional play'. Nothing here is hardcoded, so a price change in the admin shows up. */
  XPS.forEach(function (x) {
    var v = VARIANTS[slugOf(x)]; if (!v) return;
    var f = v['First play'] || v[Object.keys(v)[0]], a = v['Additional play'];
    if (f && f.price > 0) x.price = f.price / 100;
    if (x.perPlay && a && a.price > 0) x.extra = a.price / 100;
    if (x.perPlay && x.price && x.extra) x.desc = x.groupOf
      ? 'All four pods, full squad of ' + x.groupOf + ' \u2014 ' + fmt(x.price / x.groupOf) + ' a player. Every extra play the same day is ' + fmt(x.extra) + '.'
      : 'Per player. Every extra play the same day is ' + fmt(x.extra) + '.';
  });
  /* only sell what Shopify can actually put in a cart, at a known price */
  XPS = XPS.filter(function (x) { return VARIANTS[slugOf(x)] && x.price && (!x.perPlay || x.extra); });

  function venueDate(d) { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(d); }
  function todayStr() { return venueDate(new Date()); }
  function maxDateStr() { return venueDate(new Date(Date.now() + MAX_DAYS * 86400000)); }
  /* ISO instant -> '5:00 PM' in venue time, whatever the guest's device clock says */
  function slot12(iso) { return iso ? new Date(iso).toLocaleTimeString('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit' }) : iso; }

  function rpc(fn, body) {
    return fetch(SB_URL + '/rest/v1/rpc/' + fn, {
      method: 'POST',
      headers: { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok) { var e = new Error((j && j.message) || 'HTTP ' + r.status); e.code = j && j.code; throw e; }
        return j;
      });
    });
  }

  var host = root.querySelector('[data-step-host]');
  var progEls = root.querySelectorAll('[data-prog] span');
  if (!host) return;

  var state = { step: 0, xp: null, date: '', slot: '', players: 1, plays: 1, slots: null, slotsKey: '', slotsErr: '', busy: false, msg: '' };

  var q = new URLSearchParams(location.search);
  if (q.get('xp')) { var pre = XPS.find(function (x) { return x.id === q.get('xp'); }); if (pre) { selectXp(pre); } }

  function fmtDate(iso) { if (!iso) return '—'; return new Date(iso + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }
  /* Group Play is sold by the group, so headcount is a capacity statement, not a quantity */
  function squadLabel() {
    var x = state.xp;
    return x && x.groupOf ? 'Full squad — ' + x.groupOf + ' players' : plural(state.players, 'player');
  }

  /* Per-play products bill one full-price play per PAYING UNIT, then every remaining play
     at the `extra` rate. A unit is one guest on Single Play; on Group Play the $80 covers
     the whole group of `groupOf`, so the group is a single unit however many turn up.
       4 plays, 1 guest  -> 1 x $23 + 3 x $13
       4 plays, 2 guests -> 2 x $23 + 2 x $13   (each guest's own first play is full price)
     Plays can never fall below units — everyone plays at least once. */
  function units(x) { return x && x.groupOf ? 1 : state.players; }
  /* the per-player Omni rate the group price is sold against — read from the table so the
     comparison copy can never quote a price the site no longer charges */
  function soloPrice() { var s = XPS.find(function (x) { return x.perPlay && !x.groupOf; }); return s ? s.price : 0; }
  function playsMin(x) { return units(x); }
  function playsMax(x) { return units(x) * PLAYS_PER_PERSON_MAX; }

  /* keeps players/plays inside the product's bounds after any change */
  function clamp() {
    var x = state.xp; if (!x) return;
    state.players = Math.min(Math.max(state.players, x.min), x.max);
    if (x.perPlay) state.plays = Math.min(Math.max(state.plays, playsMin(x)), playsMax(x));
  }
  /* Changing product resets the play count to its floor — one play each on Single Play,
     one group play on Group Play. Carrying it over silently opened Group Play at 4 plays
     ($200) for anyone who had been pricing a multi-play Single Play booking. */
  function selectXp(x) {
    var changed = state.xp !== x;
    if (changed) state.slot = '';
    state.xp = x;
    clamp();
    if (x.perPlay && changed) { state.plays = units(x); clamp(); }
  }

  function total() {
    var x = state.xp;
    if (!x) return 0;
    if (x.flat) return x.price;
    if (x.perPlay) {
      var u = units(x);
      return u * x.price + Math.max(0, state.plays - u) * x.extra;
    }
    var t = x.price * state.players;
    return x.squad && state.players >= SQUAD_MIN ? t * (1 - SQUAD_OFF) : t;
  }

  function renderProg() { progEls.forEach(function (el, i) { el.className = i === state.step ? 'on' : (i < state.step ? 'done' : ''); }); }
  function renderSum() {
    var sum = root.querySelector('[data-sum]'); if (!sum) return;
    var t = total();
    sum.innerHTML =
      '<div class="srow"><span>MISSION</span><b>' + (state.xp ? state.xp.name : '—') + '</b></div>' +
      '<div class="srow"><span>DATE</span><b>' + fmtDate(state.date) + '</b></div>' +
      '<div class="srow"><span>TIME</span><b>' + (slot12(state.slot) || '—') + '</b></div>' +
      '<div class="srow"><span>SQUAD</span><b>' + (state.xp ? squadLabel() : '—') + '</b></div>' +
      (state.xp && state.xp.perPlay ? '<div class="srow"><span>PLAYS</span><b>' + plural(state.plays, 'play') + '</b></div>' : '') +
      '<div class="srow grand"><span>EST. TOTAL</span><b>' + (t ? fmt(t) : '—') + '</b></div>';
  }
  function navHtml(backLabel, nextLabel, nextDisabled) {
    return '<div class="bk-nav">' +
      '<button type="button" class="backbtn" data-back' + (state.step === 0 ? ' disabled' : '') + '>‹ ' + (backLabel || 'Back') + '</button>' +
      '<button type="button" class="cbtn cbtn-primary" data-next' + (nextDisabled ? ' style="opacity:0.4;pointer-events:none;"' : '') + '>' + nextLabel + '</button>' +
    '</div>';
  }

  function step0() {
    var GROUPS = [
      { label: 'OMNI ARENA', hue: '#FF3BF0', ids: ['omni', 'omnig'] },
      { label: 'FREE ROAM', hue: '#8F6BFF', ids: ['freeroam', 'freeroamp', 'freeroam2', 'freeroam2p'] },
      { label: 'DREAM PARK', hue: '#00D4B8', ids: ['dreampark', 'dreampark4'] }
    ];
    function pickHtml(x) {
      var priceStr = fmt(x.price) + (x.flat ? '' : '<small style="font-size:11px;color:var(--lmut);">/' + (x.extra ? 'play' : 'pp') + '</small>');
      return '<button type="button" class="xp-pick' + (state.xp && state.xp.id === x.id ? ' on' : '') + '" data-xp="' + x.id + '">' +
        '<span class="pp">' + priceStr + '</span><b>' + (x.short || x.name) + '</b><i>' + x.meta + '</i><span>' + x.desc + '</span></button>';
    }
    var colsHtml = GROUPS.map(function (g) {
      var picks = g.ids.map(function (id) { var x = XPS.find(function (xp) { return xp.id === id; }); return x ? pickHtml(x) : ''; }).join('');
      return '<div class="xp-col"><div class="xp-col-head" style="--phue:' + g.hue + ';">' + g.label + '</div>' + picks + '</div>';
    }).join('');
    host.innerHTML = '<h3>SELECT YOUR MISSION</h3><div class="xp-cols">' + colsHtml + '</div>' + navHtml(null, 'Next — Squad ›', !state.xp);
    host.querySelectorAll('[data-xp]').forEach(function (b) {
      b.addEventListener('click', function () { selectXp(XPS.find(function (x) { return x.id === b.getAttribute('data-xp'); })); render(); });
    });
  }
  /* Date & time step: slots come live from get_availability for this exact party. */
  function slotsKey() {
    var x = state.xp;
    return [slugOf(x), state.date, state.players, x.perPlay ? state.plays : ''].join('|');
  }
  function loadSlots() {
    var x = state.xp, key = slotsKey();
    /* Already loaded (or in flight) for this exact party: just redraw — the step's HTML was
       rebuilt, so returning without renderSlots() left an empty grid after Back. */
    if (state.slotsKey === key && (state.slots || !state.slotsErr)) { renderSlots(); return; }
    state.slotsKey = key; state.slots = null; state.slotsErr = '';
    rpc('get_availability', { p_exp_slug: slugOf(x), p_on_date: state.date, p_party_size: state.players, p_plays: x.perPlay ? state.plays : null })
      .then(function (rows) { if (state.slotsKey === key) { state.slots = rows || []; renderSlots(); } })
      .catch(function (e) { if (state.slotsKey === key) { state.slotsErr = e.code === '22023' ? e.message : 'Could not load times — check your connection and try again.'; renderSlots(); } });
    renderSlots();
  }
  function step1() {
    if (!state.date) state.date = todayStr();
    host.innerHTML = '<h3>PICK A LAUNCH WINDOW</h3>' +
      '<div class="field" style="max-width:280px;"><label for="bk-date">Date</label><input id="bk-date" type="date" value="' + state.date + '" min="' + todayStr() + '" max="' + maxDateStr() + '"></div>' +
      '<div><h3 style="margin-bottom:12px;">AVAILABLE SLOTS</h3>' +
      '<p class="slot-note mono">ALL TIMES EASTERN (WILLIAMSBURG, VA)</p>' +
      '<div class="slotgrid" data-slots></div><p class="hint" data-slot-msg style="margin-top:10px;"></p></div>' + navHtml('Squad', 'Review Booking ›', !state.slot);
    var di = host.querySelector('#bk-date');
    di.addEventListener('change', function () {
      /* ignore cleared / out-of-range typing */
      if (!di.value || di.value < todayStr() || di.value > maxDateStr()) { di.value = state.date; return; }
      state.date = di.value; state.slot = ''; render();
    });
    loadSlots();
  }
  function renderSlots() {
    var grid = host.querySelector('[data-slots]'), msg = host.querySelector('[data-slot-msg]');
    if (!grid) return;
    var note = state.msg || '';
    if (state.slotsErr) {
      note = state.slotsErr + ' <a href="#" data-retry>Retry</a>';
    } else if (!state.slots) {
      note = 'Loading times…';
    } else if (!state.slots.length) {
      note = 'Nothing bookable on this date — try another day.';
    }
    if (msg) msg.innerHTML = note;
    var retry = host.querySelector('[data-retry]');
    if (retry) retry.addEventListener('click', function (e) { e.preventDefault(); state.slotsKey = ''; state.msg = ''; loadSlots(); });
    grid.innerHTML = (state.slots || []).map(function (s) {
      var off = !s.open;
      return '<button type="button" class="slot' + (off ? ' off' : '') + (state.slot === s.starts_at ? ' on' : '') + '" data-slot="' + s.starts_at + '"' + (off ? ' disabled title="Unavailable" aria-label="' + slot12(s.starts_at) + ' unavailable"' : '') + '>' + slot12(s.starts_at) + '</button>';
    }).join('');
    grid.querySelectorAll('[data-slot]:not(.off)').forEach(function (b) { b.addEventListener('click', function () { state.slot = b.getAttribute('data-slot'); state.msg = ''; render(); }); });
  }
  /* Itemised so the guest can see WHY the number is what it is — the repeat-play discount
     only pulls extra plays if they can watch it apply. Returns [{label, amount}, …]. */
  function breakdown() {
    var x = state.xp; if (!x || !x.perPlay) return [];
    var u = units(x), rest = Math.max(0, state.plays - u);
    var firstLabel = x.groupOf
      ? 'First play — full squad of ' + x.groupOf
      : plural(u, 'first play') + ' — one per player';
    var rows = [{ label: firstLabel + ' × ' + fmt(x.price), amount: u * x.price }];
    if (rest) rows.push({ label: plural(rest, 'additional play') + ' same day × ' + fmt(x.extra), amount: rest * x.extra });
    return rows;
  }
  /* what the same booking would cost with no repeat-play discount */
  function savedVsFull() {
    var x = state.xp; if (!x || !x.perPlay) return 0;
    return state.plays * x.price - total();
  }
  function breakdownHtml() {
    var rows = breakdown(); if (!rows.length) return '';
    var save = savedVsFull();
    var html = rows.map(function (r) {
      return '<div style="display:flex; justify-content:space-between; gap:16px; padding:3px 0;">' +
        '<span>' + r.label + '</span><b>' + fmt(r.amount) + '</b></div>';
    }).join('');
    html += '<div style="display:flex; justify-content:space-between; gap:16px; padding:8px 0 0; margin-top:6px; border-top:1px solid var(--lline);">' +
      '<span><b>Estimated total</b></span><b>' + fmt(total()) + '</b></div>';
    if (save > 0) html += '<div style="margin-top:8px; color:var(--lacc);">⚡ You save <b>' + fmt(save) + '</b> versus paying full price for every play.</div>';
    else html += '<div style="margin-top:8px; color:var(--lmut);">Add a play — every extra play the same day is ' + fmt(state.xp.extra) + ' instead of ' + fmt(state.xp.price) + '.</div>';
    return '<div class="clip-sm" style="padding:14px 16px; margin-top:14px; border:1px solid var(--lline); background:var(--lmist); font-size:13.5px; line-height:1.6;">' + html + '</div>';
  }
  function counterHtml(key, value, hint) {
    return '<div class="pcount"><div class="qty">' +
      '<button type="button" data-dec="' + key + '" aria-label="Fewer ' + key + '">−</button><b>' + value + '</b>' +
      '<button type="button" data-inc="' + key + '" aria-label="More ' + key + '">+</button></div>' +
      '<span class="hint">' + hint + '</span></div>';
  }
  function step2() {
    var x = state.xp;
    var counters, heading;
    if (x.perPlay) {
      heading = 'SQUAD &amp; PLAYS';
      /* Group Play is one price for the whole group, so it has no player counter —
         adding people would not change what they pay. */
      counters = (x.groupOf
        ? '<p class="hint" style="margin-bottom:12px;">Group Play is a full squad of ' + x.groupOf + ' across all four pods — ' + fmt(x.price / x.groupOf) + ' a player, against ' + fmt(soloPrice()) + ' each on Single Play.</p>'
        : counterHtml('players', state.players, plural(state.players, 'player') + ' · each player&rsquo;s first play is ' + fmt(x.price) + '.')) +
        counterHtml('plays', state.plays, plural(state.plays, 'play') + ' total · ' + fmt(x.extra) + ' each after the first' + (x.groupOf ? '' : ' per player') + ' · 10 min per play.');
    } else {
      heading = 'ASSEMBLE THE SQUAD';
      var rate = x.flat ? ' (flat rate)'
        : ' · ' + fmt(x.price) + ' per player' + (x.squad ? ', ' + Math.round(SQUAD_OFF * 100) + '% off at ' + SQUAD_MIN + '+' : '');
      counters = counterHtml('players', state.players, x.name + ' supports ' + x.min + '–' + x.max + ' players' + rate + '.');
    }
    host.innerHTML = '<h3>' + heading + '</h3>' + counters + breakdownHtml() +
      navHtml('Mission', 'Next — Date &amp; Time ›', false);
    /* one handler for both counters; clamp() enforces plays >= players so dropping a
       player can never leave a booking priced for people who are not coming */
    host.querySelectorAll('[data-dec],[data-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-dec') || b.getAttribute('data-inc');
        state[key] += b.hasAttribute('data-inc') ? 1 : -1;
        if (key === 'players' && state.xp.perPlay && state.plays < state.players) state.plays = state.players;
        clamp();
        state.slot = '';
        render();
      });
    });
  }
  function step3() {
    host.innerHTML = '<h3>CONFIRM THE DROP</h3><div class="review-grid">' +
      '<div class="rv-item"><b>MISSION</b><span>' + state.xp.name + '</span></div>' +
      '<div class="rv-item"><b>DATE &amp; TIME</b><span>' + fmtDate(state.date) + ' · ' + slot12(state.slot) + '</span></div>' +
      '<div class="rv-item"><b>SQUAD SIZE</b><span>' + squadLabel() + '</span></div>' +
      (state.xp.perPlay ? '<div class="rv-item"><b>PLAYS</b><span>' + plural(state.plays, 'play') + ' · 10 min each</span></div>' : '') +
      '<div class="rv-item"><b>EST. TOTAL</b><span>' + fmt(total()) + '</span></div></div>' +
      breakdownHtml() +
      '<p style="font-size:13px; color:var(--lmut);">We hold your slot for 20 minutes while you pay at secure checkout. Free reschedule up to 24h before launch.</p>' +
      '<p class="hint" data-submit-msg style="color:var(--lacc);">' + state.msg + '</p>' +
      navHtml('Date &amp; Time', state.busy ? 'Holding your slot…' : 'Hold Slot &amp; Pay ›', state.busy);
  }
  /* evtForm validators (private-event inquiry) */
  function validPhone(v) { return String(v).replace(/\D/g, '').length >= 7; }
  function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

  function postJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }
  /* A guest must not stack an older hold: drop any line that already carries _booking_id. */
  function clearOldHolds() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (it) { if (it.properties && it.properties._booking_id) updates[it.key] = 0; });
      return Object.keys(updates).length ? postJson('/cart/update.js', { updates: updates }) : null;
    });
  }
  function cartItems(bookingId) {
    var x = state.xp, v = VARIANTS[slugOf(x)];
    var props = { _booking_id: bookingId, Date: fmtDate(state.date), Time: slot12(state.slot), Players: String(state.players) };
    /* Plays rides on the first line only — on both, checkout printed it twice. */
    function line(id, qty, extra) { var p = {}; for (var k in props) p[k] = props[k]; for (k in extra) p[k] = extra[k]; return { id: id, quantity: qty, properties: p }; }
    if (!x.perPlay) return [line(v[Object.keys(v)[0]].id, x.flat ? 1 : state.players)];
    var first = v['First play'].id, more = v['Additional play'].id, u = units(x), rest = state.plays - u;
    var items = [line(first, u, { Plays: String(state.plays) })];
    if (rest > 0) items.push(line(more, rest));
    return items;
  }
  function submitMsg(t, busy) {
    state.msg = t; state.busy = !!busy; render();
  }
  function submitBooking() {
    if (state.busy) return;
    var x = state.xp;
    submitMsg('', true);
    rpc('hold_slot', { p_exp_slug: slugOf(x), p_starts_at: state.slot, p_players: state.players, p_plays: x.perPlay ? state.plays : null })
      .then(function (rows) {
        var h = rows && rows[0];
        if (!h || !h.booking_id) throw new Error('no hold');
        return clearOldHolds().then(function () { return postJson('/cart/add.js', { items: cartItems(h.booking_id) }); });
      })
      .then(function () {
        submitMsg('Held for 20 minutes — complete checkout to confirm. Taking you to checkout…', true);
        window.location.href = '/checkout';
      })
      .catch(function (e) {
        var m;
        if (e.code === '23505') { state.slot = ''; state.slotsKey = ''; state.step = 2; m = 'That time was just taken — pick another.'; }
        else if (e.code === '53400') m = 'We are busy right now — please try again in a moment.';
        else if (e.code === '22023') m = e.message;
        else m = 'Could not reach the booking system — check your connection and try again. Nothing was added to your cart.';
        submitMsg(m, false);
      });
  }

  function render() {
    renderProg();
    renderSum();
    [step0, step2, step1, step3][state.step]();
    var back = host.querySelector('[data-back]'), next = host.querySelector('[data-next]');
    if (back) back.addEventListener('click', function () { state.step--; state.msg = ''; render(); scrollTop(); });
    if (next) next.addEventListener('click', function () {
      if (state.step === 3) { submitBooking(); return; }
      state.step++; state.msg = ''; render(); scrollTop();
    });
  }
  function scrollTop() { var b = document.getElementById('book'); if (b) window.scrollTo({ top: b.offsetTop - 70, behavior: 'smooth' }); }

  /* ---------- event request packages ---------- */
  var evtForm = document.querySelector('[data-evt-form]');
  document.querySelectorAll('[data-evt]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sel = document.getElementById('ev-type'); if (sel) sel.value = b.getAttribute('data-evt');
      var card = document.getElementById('evt-form-card');
      if (card) window.scrollTo({ top: card.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
      if (RL.toast) RL.toast('PACKAGE SELECTED // ' + b.getAttribute('data-evt').toUpperCase());
    });
  });
  if (evtForm) {
    evtForm.addEventListener('submit', function (e) {
      var ok = true;
      [['ev-name', function (v) { return !!v.trim(); }], ['ev-email', validEmail], ['ev-phone', validPhone], ['ev-date', function (v) { return !!v; }]].forEach(function (pair) {
        var input = document.getElementById(pair[0]); if (!input) return;
        var good = pair[1](input.value); input.closest('.field').classList.toggle('bad', !good); if (!good) ok = false;
      });
      if (!ok) e.preventDefault();
    });
  }

  /* event type preselect + scroll for ?type=event */
  if (q.get('type') === 'event') {
    setTimeout(function () { var el = document.getElementById('events'); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' }); }, 300);
  }

  /* start the wizard */
  render();
})();
